import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { checkCodeRequest, checkCodeSuccess, checkCodeFailure } from '../reducers/checkProjectCode';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/checkProjectCode`;

function* checkCodeAxios() {

  const state = yield select(fullState => fullState);

  const {
    email,
    programCode,
    identityNo,
  } = state.form.registration.values;
  const response = yield call(() => {

  return axios({
    method: 'post',
    url: API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    data: {
      
      email: email,
     
      programCode: programCode,
      
      identityNo: identityNo,
     
    },
  });
});

  return response;
}

function* workerCheckCodeSaga() {
  
  try {
    const response = yield call(checkCodeAxios);
    const responseFromCheckCode = response.data;

    yield put(checkCodeSuccess(responseFromCheckCode));
    if (response.status === 500) {
      yield put(checkCodeFailure(responseFromCheckCode));
    }
  } catch (error) {
    yield put(checkCodeFailure(error));
  }
}

export function* watcherCheckCodeSaga() {
  yield takeLatest(checkCodeRequest().type, workerCheckCodeSaga);
}
